var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-center pa-8",style:(_vm.formActionsStyles)},[_c('TextButton',{staticClass:"mr-2",attrs:{"label":_vm.t$('.cancel')},on:{"click":_vm.emitCancel}}),_vm._v(" "),_c('Button',{attrs:{"disabled":_vm.disableSaveButton,"btn-label":_vm.t$('.save')},on:{"click":_vm.emitSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }